exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scrollbar .el-table__body-wrapper::-webkit-scrollbar{width:1px}.scrollbar .el-table__body-wrapper::-webkit-scrollbar-thumb{background:#99a9bf;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bbef945a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/business.vue
// module id = 1189
// module chunks = 0